/* global gon */

const KOMPASSIFY_SCRIPT_ID = 'kompassious'
const KOMPASSIFY_LOAD_LISTENER_FLAG = 'kompassifyLoadListenerAttached'

const kompassifyEnabled = () => Boolean(typeof gon !== 'undefined' && gon?.kompassify)

const identifyKompassifyUser = () => {
  if (!kompassifyEnabled()) return false

  const userId = gon.kompassify.user_id

  if (!userId) {
    console.warn('Kompassify user_id is missing. identifyUser was skipped.')
    return true
  }

  if (!window.KompassifyJS) return false

  window.KompassifyJS.identifyUser({
    userId,
    firstName: gon.kompassify.user_first_name,
    lastName: gon.kompassify.user_last_name,
    companyId: gon.kompassify.company_id,
    companyName: gon.kompassify.company_name,
    email: gon.kompassify.user_email,
    segments: [gon.kompassify.user_role]
  })

  return true
}

const subscribeToKompassifyScriptLoad = () => {
  const script = document.getElementById(KOMPASSIFY_SCRIPT_ID)
  if (!script) {
    console.warn('Kompassify script tag was not found in DOM')
    return
  }

  if (script.dataset[KOMPASSIFY_LOAD_LISTENER_FLAG] === '1') return

  script.dataset[KOMPASSIFY_LOAD_LISTENER_FLAG] = '1'
  script.addEventListener('load', identifyKompassifyUser, { once: true })
  script.addEventListener('error', () => {
    console.warn('Kompassify script failed to load')
  }, { once: true })
}

const initializeKompassify = () => {
  if (!kompassifyEnabled()) return
  if (identifyKompassifyUser()) return

  subscribeToKompassifyScriptLoad()
}

initializeKompassify()
document.addEventListener('DOMContentLoaded', initializeKompassify)
document.addEventListener('turbo:load', initializeKompassify)
